import { Link } from 'react-router-dom';
import { CheckCircle, Users } from 'lucide-react';
import { formatPrice, seatViewUrl, type Listing } from '../lib/api';
import { isDemoListing } from '../lib/demo';

/** Ticket listing row per the design system: seat info left, price + CTA right. */
export default function ListingCard({ listing }: { listing: Listing }) {
  const remaining = listing.quantity_available - listing.quantity_sold;
  const seats: string[] = JSON.parse(listing.seats_json);
  const sample = isDemoListing(listing.listing_id);
  return (
    <div className="card card-hover flex items-center gap-4">
      {listing.seat_view_photo_url && (
        <img
          src={seatViewUrl(listing.seat_block_id)}
          alt={`View from section ${listing.section}`}
          loading="lazy"
          className="hidden sm:block w-28 h-20 object-cover rounded-md shrink-0"
        />
      )}
      <div className="flex-1 min-w-0">
        <p className="text-base sm:text-lg font-bold text-ink-900 m-0">
          Sec {listing.section} · Row {listing.row} · Seats {seats.join(', ')}
        </p>
        <p className="text-sm muted mt-0.5 mb-2">
          {listing.opponent} · {listing.game_date}
          {listing.kickoff_time ? ` · ${listing.kickoff_time}` : ''}
        </p>
        <div className="flex items-center gap-2 flex-wrap">
          {sample ? (
            <span className="badge sample">Sample</span>
          ) : (
            <span className="badge verified">
              <CheckCircle size={10} /> Verified
            </span>
          )}
          <span className="badge">{listing.section_type}</span>
          <span className="text-xs muted">
            <Users size={11} className="inline mr-0.5 -mt-0.5" />
            {remaining} available
          </span>
        </div>
        {listing.listing_note && <p className="text-xs muted mt-1.5 mb-0">"{listing.listing_note}"</p>}
      </div>
      <div className="text-right shrink-0">
        <p className="text-2xl font-bold text-giants-blue tabular-nums m-0">
          {formatPrice(listing.price_per_seat_cents)}
        </p>
        <p className="text-xs muted mt-0.5 mb-2">per seat</p>
        {sample ? (
          <span
            className="btn opacity-50 cursor-not-allowed"
            title="Sample listing — turn off demo data to hide"
          >
            Sample
          </span>
        ) : (
          <Link to={`/checkout/${listing.listing_id}`} className="btn">
            Buy now
          </Link>
        )}
      </div>
    </div>
  );
}
